/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    // One clear at a time: clicks while one is on its way do nothing. A
    // clear that fails says so above the lines (#CartDrawer-Error), as a
    // failed line update does, and leaves the drawer as it was.
    onSubmitHandler() {
      if (this.clearing) return;
      this.clearing = true;
      this.classList.add('loading');
      this.drawer?.querySelector('#CartDrawer-Error')?.setAttribute('hidden', '');
      const notesEl = document.getElementById('mini-cart__notes');
      const request = themeFetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify(notesEl ? { note: notesEl.value } : {})
      });

      // The lines it removes are the drawer's rows, identified by key, read
      // before the drawer is redrawn.
      const lines = Array.from((this.drawer || this).querySelectorAll('.qty[data-key]'))
        .map((input) => ({ id: input.dataset.key, quantity: 0 }));

      request
        .then((response) => {
          // shopify:cart:lines-update, once the lines are gone (a failed
          // clear is a shopify:cart:error only). /cart/clear.js responds
          // with the emptied cart.
          if (lines.length) {
            publishStandardEvent('CartLinesUpdateEvent', {
              action: 'remove',
              context: 'dialog',
              lines: lines,
              promise: response.json()
                .then((cart) => ({ cart: standardEventCart(cart) }))
                .catch(() => ({ cart: null }))
            }, this);
          }
          this.classList.remove('loading');
          return this.drawer?.refresh();
        }, (error) => {
          console.error(error);
          publishStandardEvent('CartErrorEvent', standardEventCartError(theme.strings.cartError));
          this.classList.remove('loading');
          this.drawer?.showLineError(null, theme.strings.cartError);
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.clearing = false;
        });
    }
  }
  customElements.define('remove-all', RemoveAll);
}
